import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Filters } from '../../../services/';
import { Table, TableButtons } from '../../../components';
import moment from 'moment';

const TickettypesWindowsTable = ({ tickettypes }) => {
    const { t, i18n } = useTranslation();

    const windows = useMemo(() => tickettypes?.reduce((all, tickettype) => {
        if (!tickettype.windows?.length)
            return all;

        return [
            ...all,
            ...tickettype.windows.map((window, index) => ({
                _id: tickettype._id,
                tickettype_name: tickettype.name[i18n.language] ?? tickettype.name[Object.keys(tickettype.name)[0]],
                index: index + 1,
                ...window
            }))
        ];
    }, []), [tickettypes]);

    const has_start_at     = useMemo(() => windows?.reduce((has, window) => has || !!window.start_at, false));
    const has_stop_at      = useMemo(() => windows?.reduce((has, window) => has || !!window.stop_at, false));
    const has_duration     = useMemo(() => windows?.reduce((has, window) => has || !!window.duration, false));
    const has_screening_id = useMemo(() => windows?.reduce((has, window) => has || !!window.screening_id, false));

    const columns = [{
        Header: t('common.tickettype', {count: 1}),
        accessor: 'tickettype_name',
        filterMethod: Filters.textFilterMethod('tickettype_name'),
        Filter: Filters.textFilter,
        filterAll: true,
        Cell: row => row.value ?? '-'
    }];
    if (has_start_at)
        columns.push({
            Header: t('tickettypes.window.start_at'),
            accessor: 'start_at',
            filterable: false,
            className: 'text-center',
            Cell: row => row.value ? moment(row.value).format('LLL') : '-'
        });
    if (has_stop_at)
        columns.push({
            Header: t('tickettypes.window.stop_at'),
            accessor: 'stop_at',
            filterable: false,
            className: 'text-center',
            Cell: row => row.value ? moment(row.value).format('LLL') : '-'
        });
    columns.push({
        Header: t('tickettypes.window.nbookings'),
        accessor: 'nbookings',
        maxWidth: 50,
        className: 'text-center',
        filterable: false
    });
    columns.push({
        Header: t('tickettypes.window.nsame_screening'),
        accessor: 'nsame_screening',
        maxWidth: 50,
        className: 'text-center',
        filterable: false
    });
    columns.push({
        Header: t('tickettypes.window.overlap'),
        accessor: 'overlap',
        maxWidth: 150,
        className: 'text-center',
        filterable: false
    });
    columns.push({
        Header: t('tickettypes.window.same_day'),
        accessor: 'same_day',
        maxWidth: 110,
        className: 'text-center',
        filterable: false
    });
    if (has_duration) {
        columns.push({
            Header: t('tickettypes.window.duration'),
            accessor: 'duration',
            className: 'text-center',
            filterable: false
        });
    }
    if (has_screening_id) {
        columns.push({
            Header: t('tickettypes.window.screening_id'),
            accessor: 'screening_id',
            className: 'text-center',
            filterable: false
        });
    }
    columns.push({
        Header: t("common.actions"),
        accessor: "_id",
        maxWidth: 80,
        filterable: false,
        Cell: row => (
            <TableButtons
                id={row.value}
                actions={["edit"]}
                module="tickettypes"
            />
        )
    });

    if (!tickettypes?.length || !windows?.length)
        return null;

    return (
        <div className="TickettypesWindowsTable">
            <Table id="tickettypesWindowsTable" data={windows} columns={columns} />
        </div>
    );
}

export default TickettypesWindowsTable;
